import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';
import ReactGA from 'react-ga4';

// Function to send Web Vitals to Google Analytics
const sendToAnalytics = (metric) => {
  if (!metric || !metric.name) return; // Prevent error if metric is undefined

  // Send to Google Analytics (gtag)
  if (window.gtag) {
    window.gtag('event', metric.name, {
      value: metric.value,
      event_category: 'Web Vitals',
      event_label: metric.id,
      non_interaction: true,
    });
  }

  // Send to react-ga4
  ReactGA.event({
    category: 'Web Vitals',
    action: metric.name,
    value: Math.round(metric.value),
    label: metric.id,
    nonInteraction: true,
  });
};

// Function to log custom events to Google Analytics
export const logCustomEvent = (eventName, eventParams = {}) => {
  ReactGA.event({
    category: eventParams.category || 'User Interaction', // Default category
    action: eventName,
    label: eventParams.label || 'Custom Event', // Optional label
    value: eventParams.value || undefined, // Optional value (must be an integer)
    nonInteraction: eventParams.nonInteraction || false, // Optional, default to false for user interactions
    ...eventParams, // Spread additional parameters if provided
  });

  // Optionally send to gtag if needed
  if (window.gtag) {
    window.gtag('event', eventName, {
      event_category: eventParams.category || 'User Interaction',
      event_label: eventParams.label || 'Custom Event',
      value: eventParams.value,
      non_interaction: eventParams.nonInteraction || false,
      ...eventParams,
    });
  }
};

// Add page view tracking
export const trackPageView = (pageTitle, pagePath) => {
  ReactGA.send({
    hitType: 'pageview',
    page: pagePath,
    title: pageTitle,
  });
};

// Existing Web Vitals reporting function
const reportWebVitals = (onPerfEntry = sendToAnalytics) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    getCLS(onPerfEntry);
    getFID(onPerfEntry);
    getFCP(onPerfEntry);
    getLCP(onPerfEntry);
    getTTFB(onPerfEntry);
  }
};

export default reportWebVitals;